const GetUserType = () => {
  const userType = window.localStorage.getItem('user_role');

  return userType;
};

export default GetUserType;
